const setCopySnackbar = (open) => ({
  type: 'SET_COPY_SNACKBAR',
  open
});

export const startSetCopySnackbar = (open) => {
  return (dispatch) => {
    dispatch(setCopySnackbar(open));
  }
}